export const changeCoverReferenceData = {
  changeCoverInformationText: {
    informationText:
      '<p>Change my&nbsp;cover allows you&nbsp;to&nbsp;change your&nbsp;product,&nbsp;add/remove/replace people&nbsp;on&nbsp;your policy, and&nbsp;make updates&nbsp;to&nbsp;your eligibility&nbsp;and&nbsp;rebate all at&nbsp;once. Some changes&nbsp;to&nbsp;details will&nbsp;require you to&nbsp;select a&nbsp;new&nbsp;product to meet&nbsp;your new&nbsp;needs.</p>\r\n',
  },
  changeCoverSubheadingTitleText: {
    informationText: 'How can you change your cover?',
  },
  changeCoverSubheadingText: {
    informationText: 'Review your current&nbsp;level of cover,&nbsp;compare other&nbsp;products and&nbsp;review your current&nbsp;needs.&nbsp;',
  },
  changeYourProductSubheadingText: {
    informationText:
      '<h3>Change your product</h3>\r\n\r\n<ul>\r\n\t<li>Receive quote for new product</li>\r\n\t<li>Add dependants to suitable cover</li>\r\n\t<li>Confirm eligibility for selected cover</li>\r\n</ul>\r\n',
  },
  changeYourProductButtonText: {
    informationText: 'Change my product',
  },
  addOrRemovePersonSubheadingText: {
    informationText: '<h3>Add or remove a person</h3>\r\n\r\n<ul>\r\n\t<li>Keep current couples or family&nbsp;product and change people covered</li>\r\n</ul>\r\n',
  },
  addOrRemovePersonButtonText: {
    informationText: 'Add or remove a person',
  },
  viewMemberDetailsSubheadingText: {
    informationText:
      '<h3>View your member details</h3>\r\n\r\n<p>Visit&nbsp;<a href="/portal/$memberNumber$/Member-Selection/Member-Details">member details</a>&nbsp;to check personal profile and access. To update member or rebate details,&nbsp;please <a href="/portal/$memberNumber$/Support/Contact-Us">contact us</a> and&nbsp;we&#39;ll&nbsp;be&nbsp;happy to help.</p>\r\n',
  },
  accessDeniedErrorText: {
    informationText:
      '<p>If you would like to make changes to your product or add or remove a person on this policy, please talk to your policy holder. They will need to make a change to your cover within the member portal or ask them to contact Defence health to request the change.</p>',
  },
  startDateEqualToCurrentDateErrorText: {
    informationText:
      '<p>You cannot make a change to cover on the same day your cover was created. If you would like to make a change to your cover please return to this page one day after your cover start date.</p>',
  },
};

export const addRemovePersonReferenceData = {
  addRemovePersonTitleText: {
    informationText: 'Add or remove a person',
  },
  addRemovePersonDescriptionText: {
    informationText: `Add or remove a person from your current product and retain your existing product.<br />\r\n<br />\r\nAdding a child may require a change of product for family cover. Only the policy holder can remove themselves. Call us on <a href='tel:1800335425'>1800 335 425</a>. to change the rebate applicant.`,
  },
  partnerFormFieldHelperText: {
    informationText: `Some member details can only be changed by the policy holder. Please call us at <a href='tel:1800335425'>1800 335 425</a>. If you need help.`,
  },
  partnerRemovalAcknowledgementText: {
    informationText: 'I acknowledge that I have communicated to the policy holder that their eligibility to the policy will change as a result of this adult being removed.',
  },
  partnerVeteranCardGoldText: {
    informationText: 'Private Health Insurance is not generally required in addition to a Veteran Gold Card.',
  },
  partnerVeteranCardWhiteText: {
    informationText:
      'By providing your Veteran Card details, you agree to claim eligible benefit entitlements through DVA first.<br />\r\n<br />\r\nUsing the search below, select all the conditions that are listed as covered by your Veteran White Card.',
  },
  partnerConcessionHelperText: {
    informationText:
      'Advising us whether you hold a concession card ensures we are not paying for services that you are already entitled to, which helps us keep premiums more&nbsp;affordable.',
  },
  partnerLHCSupportText: {
    informationText: `Compare the member's current cover with other options. The answers below have been pre-filled using the details on the membership. Adjust the answers based on the member's needs to see product recommendations.`,
  },
  childNameHelperText: {
    informationText: `Some member details can only be changed by the policy holder. Please call us at <a href='tel:1800335425'>1800 335 425</a>. If you need help.`,
  },
  childDetailAcknowledgementText: {
    informationText: 'I declare the details that I have provided are true and correct.',
  },
  confirmationNoExcessChangeInformationText: {
    informationText:
      'The changes to your policy may impact your premium.<br />\r\n<br />\r\nYour new composition supports your current excess, no change to your excess is required.',
  },
  confirmationExcessChangeInformationText: {
    informationText: 'Due to this policy change you are required to nominate a new excess for your policy.',
  },
  confirmationExcessChangeHelperText: {
    informationText:
      'The excess options available to you will depend on the product you are currently on and your composition.<br />\r\n<br />\r\nYour updated premium will be calculated based on the excess you select.',
  },
  confirmationExcessChangeSubmitText: {
    informationText: 'Please submit below if you would like to make this change.',
  },
};

export const mpCoverDetails = {
  membership: {
    composition: 'family',
    excess: 750.0,
    datePaidTo: '',
    frequency: 'fortnightly',
    rebateTier: 'TIER_1',
    premiumInformation: {
      currentOngoingPremium: '281.49',
      discounts: {
        rebateDiscount: '',
        dvaDiscount: '',
        abdDiscount: '',
        adfDiscount: '',
        lhcSurcharge: '0%',
        reservistDiscount: '',
        transitionDiscount: '-10%',
        veteranDiscount: '-5%',
      },
    },
    coverStartDate: '2024-01-22',
    rebateApplicant: 'Member-100200000000', // Remove X to make partner the rebate applicant
    rebateCommencementDate: '',
    rebateRegistrationEventStatus: '',
    rebateRegistrationEventType: '',
    myCircumstances: '',
    premiumPaymentAccount: {
      code: '1653',
      startDate: '2024-01-22',
      endDate: '',
      expiryYear: null,
      expiryMonth: null,
      id: '66867',
      accountType: 'B',
      accountHolderName: 'Test',
      accountNumberOrToken: '988765542',
      bsb: '123456',
      maskedCreditCardNumber: null,
      expiryDate: '',
    },
  },
  eligibility: {
    eligibilityType: 'Ex-Serving',
    whoIsEligible: 'Self',
    rank: 'Rank',
    partnersName: null,
    dateOfEnlistment: '2023-11-11',
    dateOfDischarge: '2023-12-12',
    eligibilityDeclaration: true,
    sercatStatus: null,
    whatIsRelationshipConnection: null,
    exServing: 'Permanent',
    howAreTheyEligible: null,
    currentlyServing: 'Airforce',
    eligibilityDeclarationDate: '2024-01-23',
    adfDeclarationExpiryDate: '2025-01-22',
    companyName: '',
    departmentName: '',
    nameOfPersonWithWorkConnection: '',
    nameOfConnectedIndividual: '',
    rankRelative: '',
    serveInRelative: 'Airforce',
    theirServiceIs: null,
  },
  members: [
    {
      name: 'Test Child Family',
      personCode: 'Member-1006',
      insurableType: 'D',
      sex: '',
      latestMemberStatus: 'Active',
      address: {
        dpId: null,
        addressType: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        suburb: null,
        postcode: null,
        state: null,
        stateLastModified: null,
      },
      firstName: 'Test',
      middleName: '',
      lastName: 'Child Family',
      dob: '2021-02-05',
      email: '',
      mobile: '',
      hasVeteranCard: false,
      hasConcessionCard: false,
      residentialAddress: {
        dpId: '53717247',
        addressType: null,
        addressLine1: '51 Johnson Dr',
        addressLine2: null,
        addressLine3: null,
        suburb: 'CALWELL',
        postcode: '2905',
        state: 'ACT',
        stateLastModified: null,
      },
      lhcOverrule: null,
      lhc: null,
      relationship: {
        name: 'Daughter',
        code: 'DTR',
      },
      claimsAccount: null,
      medicareCard: null,
      activeVeteranCard: null,
      activeConcessionCard: null,
      veteranCardAcceptedConditions: null,
      abdDetails: null,
      studentDeclaration: null,
    },
    {
      name: 'Family Hospital',
      personCode: 'Member-1002',
      insurableType: 'A',
      sex: '',
      latestMemberStatus: 'ACTIVE',
      address: {
        dpId: null,
        addressType: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        suburb: null,
        postcode: null,
        state: 'VIC',
        stateLastModified: null,
      },
      firstName: 'Family',
      middleName: '',
      lastName: 'Hospital',
      dob: '1972-01-04',
      email: 'testfamily@hos.com',
      mobile: '0455 678 234',
      hasVeteranCard: true,
      hasConcessionCard: true,
      residentialAddress: {
        dpId: '53717247',
        addressType: null,
        addressLine1: '51 Johnson Dr',
        addressLine2: null,
        addressLine3: null,
        suburb: 'CALWELL',
        postcode: '2905',
        state: 'WA',
        stateLastModified: null,
      },
      lhcOverrule: {
        code: 'IMM',
        name: 'Immigrant',
        cae: 30,
      },
      lhc: {
        certifiedAgeOfEntry: 30,
        totalAbsentDays: 0,
        paidHospitalDays: 0,
        lhcOverride: 0,
        lhcEndDate: null,
        lhcLoadingRate: 2.0,
        lhcStartDate: '2024-01-22',
        code: 'IMM',
        name: 'Immigrant',
        medicareRegistrationDate: '2023-05-29',
        returnFromOverseasDate: '',
      },
      relationship: {
        name: 'Policy Holder',
        code: 'MEMBR',
      },
      claimsAccount: {
        code: '1653',
        id: '66867',
        accountType: null,
        accountHolderName: 'Test',
        accountNumberOrToken: '988765542',
        bsb: '123456',
      },
      medicareCard: null,
      activeVeteranCard: {
        id: '12345',
        cardType: 'GOLD',
        startDate: '2024-01-22',
      },
      activeConcessionCard: {
        id: '66587',
        cardType: 'CSHC',
        cardNumber: '123456789Y',
        expiryDate: '',
        startDate: '2024-01-22',
        endDate: null,
      },
      veteranCardAcceptedConditions: null,
      abdDetails: null,
      studentDeclaration: null,
      portalAgeBasedDiscount: {
        firstTimePHI: false,
        currentlyReceived: true,
        cda: 25,
      },
    },
    {
      name: 'Test Partner Family',
      personCode: 'Member-100200000000',
      insurableType: 'A',
      sex: '',
      latestMemberStatus: 'Active',
      address: {
        dpId: null,
        addressType: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        suburb: null,
        postcode: null,
        state: 'ACT',
        stateLastModified: null,
      },
      firstName: 'Test',
      middleName: '',
      lastName: 'Partner Family',
      dob: '1977-06-11',
      email: 'testmail@mail.com',
      mobile: '0455 234 876',
      hasVeteranCard: true,
      hasConcessionCard: true,
      residentialAddress: {
        dpId: '53717247',
        addressType: null,
        addressLine1: '51 Johnson Dr',
        addressLine2: null,
        addressLine3: null,
        suburb: 'CALWELL',
        postcode: '2905',
        state: 'ACT',
        stateLastModified: null,
      },
      lhc: {
        certifiedAgeOfEntry: 30,
        totalAbsentDays: 0,
        paidHospitalDays: 0,
        lhcOverride: 0,
        lhcEndDate: null,
        lhcLoadingRate: 2.0,
        lhcStartDate: '2024-01-22',
        code: 'ADF',
        name: 'Full Time ADF',
        medicareRegistrationDate: '',
        returnFromOverseasDate: '',
      },
      lhcOverrule: null,
      relationship: {
        name: 'Spouse',
        code: 'SPS',
      },
      claimsAccount: null,
      medicareCard: null,
      activeVeteranCard: {
        id: '67890',
        cardType: 'WHITE',
        startDate: '2024-01-22',
      },
      activeConcessionCard: {
        id: '66589',
        cardType: 'HCC',
        cardNumber: '987655321Y',
        expiryDate: '2024-02-29',
        startDate: '2024-01-22',
        endDate: null,
      },
      veteranCardAcceptedConditions: [
        {
          id: '32737620845',
          code: 'DVAC2',
          startDate: '2024-10-03',
          endDate: '',
        },
        {
          id: '32737775704',
          code: 'DVAC1',
          startDate: '2024-10-03',
          endDate: '',
        },
      ],
      abdDetails: null,
      studentDeclaration: null,
      portalAgeBasedDiscount: null,
    },
  ],
  products: [
    {
      name: 'Ultimate Hospital Gold',
      productNumber: 'J19',
      productTypeCode: 1,
      validFromDate: '2017-12-01',
      validToDate: null,
      productExcessType: 527340002,
      stateCode: 0,
      statusCode: 0,
      isEligibleForAbd: false,
      productExcess: [
        {
          excess: 0,
          startDate: '2017-12-01',
          endDate: '2020-01-07',
          composition: '1,2,3,4,5,6,7',
          eligibilitySegment: '200000000,200000001,200000002,200000003',
          stateCode: 0,
          statusCode: 1,
        },
        {
          excess: 250,
          startDate: '2017-12-01',
          endDate: '2020-01-07',
          composition: '1,2,3,4,6,7',
          eligibilitySegment: '200000000,200000001,200000002,200000003',
          stateCode: 0,
          statusCode: 1,
        },
        {
          excess: 500,
          startDate: '2017-12-01',
          endDate: '',
          composition: '1,2,3,4,5,6,7',
          eligibilitySegment: '200000000,200000001,200000002,200000003',
          stateCode: 0,
          statusCode: 1,
        },
        {
          excess: 750,
          startDate: '2017-12-01',
          endDate: '',
          composition: '2,3,4,5,6,7',
          eligibilitySegment: '200000000,200000001,200000002,200000003',
          stateCode: 0,
          statusCode: 1,
        },
      ],
    },
    {
      name: 'Value Extras',
      productNumber: 'I4',
      productTypeCode: 2,
      validFromDate: '2014-09-01',
      validToDate: null,
      productExcessType: null,
      stateCode: 0,
      statusCode: 0,
      isEligibleForAbd: false,
      productExcess: [],
    },
  ],
};

export const MemberPolicies = {
  accessingPersonCode: "43868",
  memberships: [
    {
      memberNumber: "1301598",
      relationship: "Policy Holder",
      postcode: "2261",
      state: "NSW",
      policyStatus: "ACTIVE",
    },
    {
      memberNumber: "1301599",
      relationship: "Policy Holder",
      postcode: "2261",
      state: "NSW",
      policyStatus: "SUSPENDED",
    },
    {
      memberNumber: "1301597",
      relationship: "Policy Holder",
      postcode: "2261",
      state: "NSW",
      policyStatus: "TERMINATED",
    }
  ]
};

export const captureAdditionalInformationReferenceData = {
  compositionOptions: [
    {
      isShown: true,
      display: 'Single person',
      returnValue: 'single',
    },
    {
      isShown: true,
      display: 'Couple',
      returnValue: 'couple',
    },
    {
      isShown: true,
      display: 'Family',
      returnValue: 'family',
    },
    {
      isShown: true,
      display: 'Single parent family',
      returnValue: 'singleParent',
    },
    {
      isShown: true,
      display: 'Child / Children only',
      returnValue: 'childrenOnly',
    },
    {
      isShown: false,
      display: 'Family plus',
      returnValue: 'familyPlus',
    },
    {
      isShown: false,
      display: 'Single parent plus',
      returnValue: 'singleParentPlus',
    },
  ],
  sex: {
    label: null,
    helpText: 'We collect biological sex to support claims processes​',
    options: [
      {
        display: 'Male',
        returnValue: 'M',
      },
      {
        display: 'Female',
        returnValue: 'F',
      },
    ],
  },
  phoneTypeOptions: [
    {
      display: 'Mobile',
      returnValue: 'Mobile',
    },
    {
      display: 'Work',
      returnValue: 'Work',
    },
    {
      display: 'Home',
      returnValue: 'Home',
    },
  ],
  stateOptions: [
    {
      display: 'ACT',
      returnValue: 'ACT',
    },
    {
      display: 'NSW',
      returnValue: 'NSW',
    },
    {
      display: 'NT',
      returnValue: 'NT',
    },
    {
      display: 'QLD',
      returnValue: 'QLD',
    },
    {
      display: 'SA',
      returnValue: 'SA',
    },
    {
      display: 'TAS',
      returnValue: 'TAS',
    },
    {
      display: 'VIC',
      returnValue: 'VIC',
    },
    {
      display: 'WA',
      returnValue: 'WA',
    },
  ],
  communicationMethodOptions: [
    {
      display: 'Email',
      returnValue: 'Email',
    },
    {
      display: 'Post',
      returnValue: 'Post',
    },
  ],
  healthInsuranceFirstTimeHelpText: {
    informationText:
      '<p>Your certified discount age is the age you are when you take out private hospital insurance for the first time.</p>\r\n\r\n<p>We use this to apply an&nbsp;<a href="/Health-Insurance/Explore-Health-Cover/Cost-Benefits-of-Health-Insurance" target="_blank">age-based discount</a>&nbsp;on your premium.</p>\r\n',
  },
  lhcOptions: [
    {
      display: 'An Australian citizen or permanent resident recently returned from overseas',
      returnValue: 'OSE',
    },
    {
      display: 'A new migrant to Australia',
      returnValue: 'IMM',
    },
    {
      display: 'An ex-serving ADF member',
      returnValue: 'ADF',
    },
    {
      display: 'I have held hospital insurance continuously for last 10 years or since turning 31 years old',
      returnValue: 'YEA',
    },
    {
      display: 'None of the above',
      returnValue: 'NONE',
    },
  ],
  lhcMigrantHelpText: {
    informationText: '<p>We use this to assess any Lifetime Health Cover loading that needs to be applied to the premium.</p>\r\n',
  },
  firstReceiveAgeBasedDiscountOptions: {
    minimum: 18,
    maximum: 29,
    other: "I don't know",
  },
  currentlyReceivingABDHelpText: {
    informationText:
      '<p>If you are aged 18-25, you could save 10%&nbsp;on your premium every year that you remain on eligible cover with the age-based discount.</p>\r\n\r\n<p>The discount reduces by 2% annually if you take out eligible hospital cover for 26 to 29 year olds, and phases out by 2% each year after you turn 41.</p>\r\n',
  },
  currentlyReceivingABDWithAgeHelpText: {
    informationText: 'Your certified discount age may be updated when we receive the transfer certificate from your previous health fund.',
  },
  currentlyReceivingABDWithoutAgeHelpText: {
    informationText: 'We will apply a discount&nbsp; based on your age today. This may be updated when we receive the transfer certificate from your previous health fund.',
  },
  currentlyReceivingABDNoHelpText: {
    informationText:
      '<p>Your certified discount age is the age you are when you take out private hospital insurance for the first time or after you&rsquo;ve had a break in cover.</p>\r\n\r\n<p>We use this to apply&nbsp;<a href="/Health-Insurance/Explore-Health-Cover/Cost-Benefits-of-Health-Insurance" target="_blank">an age-based-discount</a>&nbsp;on your premium.</p>\r\n\r\n<p>This certified discount age may be updated when we receive the transfer certificate from your previous health fund.</p>\r\n',
  },
  insuranceFundOptions: [
    {
      isAutomaticTransfer: false,
      display: 'ACA Health Benefits Fund',
      returnValue: 'ACA',
    },
    {
      isAutomaticTransfer: false,
      display: 'AHM',
      returnValue: 'AHM',
    },
    {
      isAutomaticTransfer: false,
      display: 'AIA',
      returnValue: 'AIA',
    },
    {
      isAutomaticTransfer: false,
      display: 'APIA',
      returnValue: 'Unk9',
    },
    {
      isAutomaticTransfer: false,
      display: 'Australian Unity Health Ltd',
      returnValue: 'AU',
    },
    {
      isAutomaticTransfer: false,
      display: 'Budget Direct Health Insurance',
      returnValue: 'Unk6',
    },
    {
      isAutomaticTransfer: true,
      display: 'BUPA Health Insurance',
      returnValue: 'BUP',
    },
    {
      isAutomaticTransfer: false,
      display: 'CBHS Corporate Health Pty Ltd',
      returnValue: 'CBC',
    },
    {
      isAutomaticTransfer: false,
      display: 'CBHS Health Fund Ltd',
      returnValue: 'CBHS',
    },
    {
      isAutomaticTransfer: false,
      display: 'CDH Benefits Fund',
      returnValue: 'CDH',
    },
    {
      isAutomaticTransfer: false,
      display: 'Central West Health Fund',
      returnValue: 'Unk4',
    },
    {
      isAutomaticTransfer: false,
      display: 'CUA Health Fund',
      returnValue: 'CUA',
    },
    {
      isAutomaticTransfer: false,
      display: 'Defence Health Ltd',
      returnValue: 'AHBS',
    },
    {
      isAutomaticTransfer: true,
      display: 'Doctors Health Fund',
      returnValue: 'AMA',
    },
    {
      isAutomaticTransfer: false,
      display: 'Emergency Services Health',
      returnValue: 'ESH',
    },
    {
      isAutomaticTransfer: false,
      display: 'Fit Health Insurance',
      returnValue: 'Unk2',
    },
    {
      isAutomaticTransfer: false,
      display: 'Frank Health Insurance',
      returnValue: 'Unk1',
    },
    {
      isAutomaticTransfer: false,
      display: 'GMF Health Fund',
      returnValue: 'GMF',
    },
    {
      isAutomaticTransfer: false,
      display: 'GMHBA Health Fund',
      returnValue: 'GMHBA',
    },
    {
      isAutomaticTransfer: false,
      display: 'GU Health Fund',
      returnValue: 'GUC',
    },
    {
      isAutomaticTransfer: false,
      display: 'HBF',
      returnValue: 'HBF',
    },
    {
      isAutomaticTransfer: false,
      display: 'HCF',
      returnValue: 'HCF',
    },
    {
      isAutomaticTransfer: false,
      display: 'Health Care Insurance Ltd.',
      returnValue: 'HCI',
    },
    {
      isAutomaticTransfer: false,
      display: 'Health Partners',
      returnValue: 'HP',
    },
    {
      isAutomaticTransfer: false,
      display: 'Health.com',
      returnValue: 'Unk5',
    },
    {
      isAutomaticTransfer: false,
      display: 'HIF',
      returnValue: 'HIF',
    },
    {
      isAutomaticTransfer: false,
      display: 'Latrobe Health Services Inc',
      returnValue: 'LHS',
    },
    {
      isAutomaticTransfer: false,
      display: 'Medibank Private',
      returnValue: 'MP',
    },
    {
      isAutomaticTransfer: true,
      display: 'Mildura District Hospital Fund',
      returnValue: 'MDH',
    },
    {
      isAutomaticTransfer: false,
      display: 'Navy Health',
      returnValue: 'NAVY',
    },
    {
      isAutomaticTransfer: false,
      display: 'NIB Health Funds Limited',
      returnValue: 'NIB',
    },
    {
      isAutomaticTransfer: false,
      display: 'Nurses & Midwives Health',
      returnValue: 'NMW',
    },
    {
      isAutomaticTransfer: false,
      display: 'ONE MEDI FUND',
      returnValue: 'OMF',
    },
    {
      isAutomaticTransfer: false,
      display: 'Peoplecare',
      returnValue: 'LHMC',
    },
    {
      isAutomaticTransfer: false,
      display: 'Phoenix Health Fund',
      returnValue: 'PWAL',
    },
    {
      isAutomaticTransfer: false,
      display: 'Police Health',
      returnValue: 'SAPOL',
    },
    {
      isAutomaticTransfer: false,
      display: 'Qantas',
      returnValue: 'Unk8',
    },
    {
      isAutomaticTransfer: false,
      display: 'Queensland Country Health Limited',
      returnValue: 'QCH',
    },
    {
      isAutomaticTransfer: false,
      display: 'Queensland teachers union',
      returnValue: 'QTUHS',
    },
    {
      isAutomaticTransfer: false,
      display: 'R&T Health Fund',
      returnValue: 'RTEFS',
    },
    {
      isAutomaticTransfer: false,
      display: 'RACQ Health Insurance',
      returnValue: 'Unk7',
    },
    {
      isAutomaticTransfer: false,
      display: 'Reserve Bank Health Society',
      returnValue: 'RBHS',
    },
    {
      isAutomaticTransfer: false,
      display: "St Luke's Health",
      returnValue: 'SLMHB',
    },
    {
      isAutomaticTransfer: false,
      display: 'Teachers Health',
      returnValue: 'NSWTF',
    },
    {
      isAutomaticTransfer: false,
      display: 'Transport Health',
      returnValue: 'TFS',
    },
    {
      isAutomaticTransfer: false,
      display: 'UniHealth Insurance',
      returnValue: 'UHI',
    },
    {
      isAutomaticTransfer: false,
      display: 'Westfund',
      returnValue: 'WDHF',
    },
  ],
  insuranceFundInformationText: {
    informationText: 'By providing the details of your previous fund you authorise Defence Health to request cancellation of the products held with your previous health fund.​',
  },
  veteranCardConditionOptions: [
    {
      display: 'Alcohol Dependence & Substance Abuse',
      returnValue: 'DVAC2',
    },
    {
      display: 'Ankle & Foot',
      returnValue: 'DVAC1',
    },
    {
      display: 'Arm & Hand',
      returnValue: 'DVACD',
    },
    {
      display: 'Back',
      returnValue: 'DVAC7',
    },
    {
      display: 'Cancer (Malignant Neoplasm)',
      returnValue: 'DVAC4',
    },
    {
      display: 'Cardiac',
      returnValue: 'DVAC5',
    },
    {
      display: 'Hearing Loss/Tinnitus',
      returnValue: 'DVAC6',
    },
    {
      display: 'Hip',
      returnValue: 'DVACB',
    },
    {
      display: 'Knee',
      returnValue: 'DVACA',
    },
    {
      display: 'Mental Health Conditions',
      returnValue: 'DVAC3',
    },
    {
      display: 'Neck',
      returnValue: 'DVACC',
    },
    {
      display: 'Osteoarthritis',
      returnValue: 'DVAC8',
    },
    {
      display: 'Other',
      returnValue: 'DVACO',
    },
    {
      display: 'PTS Disorder',
      returnValue: 'DVAC9',
    },
    {
      display: 'Shoulder',
      returnValue: 'DVAC0',
    },
    {
      display: 'Pulmonary Tuberculosis',
      returnValue: 'DVACE',
    },
    {
      display: 'Skin (Non-Malignant)',
      returnValue: 'DVACF',
    },
    {
      display: 'Hernia',
      returnValue: 'DVACG',
    },
    {
      display: 'Leg & Shin',
      returnValue: 'DVACH',
    },
    {
      display: 'Diabetes',
      returnValue: 'DVACI',
    },
    {
      display: 'Irritable Bowel Syndrome',
      returnValue: 'DVACJ',
    },
    {
      display: 'Dental',
      returnValue: 'DVACK',
    },
    {
      display: 'Head & Brain',
      returnValue: 'DVACL',
    },
    {
      display: 'Reproductive',
      returnValue: 'DVACM',
    },
    {
      display: 'Lung & Chest',
      returnValue: 'DVACN',
    },
    {
      display: 'Eyes',
      returnValue: 'DVACP',
    },
  ],
  veteranCardGoldTypeInformationText: {
    informationText: 'Private Health Insurance is not generally required in addition to a DVA Gold Card. ​',
  },
  veteranCardTypeOptions: [
    {
      display: 'Veteran Gold Card',
      returnValue: 'Veteran Gold Card',
    },
    {
      display: 'Veteran White Card',
      returnValue: 'Veteran White Card',
    },
  ],
  veteranCardConditionInformationText: {
    informationText:
      '<p>By providing your&nbsp;Veteran Card details,&nbsp;you agree to claim&nbsp;eligible benefit&nbsp;entitlements through&nbsp;DVA first.​</p>\r\n\r\n<p>Using the search below, select all&nbsp;the conditions that are listed as&nbsp;covered by your Veteran White&nbsp;Card. Or upload supporting&nbsp;documents that list the conditions covered by your card.</p>\r\n',
  },
  concessionCardInformationText: {
    informationText:
      'Advising us whether you hold a concession card ensures we are not paying for services that you are already entitled to, which helps us keep premiums more affordable.',
  },
  concessionCardOptions: [
    {
      display: 'Commonwealth Seniors Health Card',
      returnValue: 'CSHC',
    },
    {
      display: 'Health Care Card',
      returnValue: 'HCC',
    },
    {
      display: 'Pensioner Concession Card',
      returnValue: 'PCC',
    },
    {
      display: 'Veterans Service Pension Card',
      returnValue: 'VSPC',
    },
  ],
  nonStudentHelpText: {
    informationText: '',
  },
  serviceConnectionOptions: [
    {
      display: 'Self',
      returnValue: 'Self',
    },
    {
      display: 'Partner',
      returnValue: 'Partner',
    },
  ],
  serviceAgencyOptions: [
    {
      display: 'Navy',
      returnValue: 'Navy',
    },
    {
      display: 'Air Force',
      returnValue: 'Air Force',
    },
    {
      display: 'Army',
      returnValue: 'Army',
    },
  ],
  serviceConnectionRelationshipOptions: [
    {
      display: 'Child',
      returnValue: 'Child',
    },
    {
      display: 'Parent',
      returnValue: 'Parent',
    },
    {
      display: 'Grandparent',
      returnValue: 'Grandparent',
    },
    {
      display: 'Brother or Sister',
      returnValue: 'Brother or Sister',
    },
    {
      display: 'Former partner',
      returnValue: 'Former partner',
    },
  ],
  sercat: {
    label: 'SERCAT 3, 4, 5, 6 or 7',
    helpText: '',
    options: [
      {
        display: 'SERCAT 3',
        returnValue: '3',
      },
      {
        display: 'SERCAT 4',
        returnValue: '4',
      },
      {
        display: 'SERCAT 5',
        returnValue: '5',
      },
      {
        display: 'SERCAT 6',
        returnValue: '6',
      },
      {
        display: 'SERCAT 7',
        returnValue: '7',
      },
    ],
  },
  eligibilityWorkedForOptions: [
    {
      display: 'Contractor',
      returnValue: 'Contractor',
    },
    {
      display: 'Defence Public Service',
      returnValue: 'Work for department',
    },
  ],
  eligibilityOptions: [
    {
      display: 'Currently serving',
      returnValue: 'Currently serving',
    },
    {
      display: 'Ex-serving',
      returnValue: 'Ex-serving',
    },
    {
      display: 'Contractor',
      returnValue: 'Contractor',
    },
    {
      display: 'Defence Public Service',
      returnValue: 'Defence Public Service',
    },
  ],
  rebateInformationText: {
    informationText:
      'The Australian Government Rebate on private health insurance may reduce the amount you pay for private health insurance. ​A rebate may still be claimed as a tax offset when you lodge your tax return.​ You can add a rebate in the Member Portal at anytime.',
  },
  rebateCoveredPolicyInformationText: {
    informationText:
      'Applicants not covered by the policy cannot claim the Australian Government Rebate on Private Health Insurance (excluding child only policies) and employers and trustees of organisations cannot claim the Australian Government Rebate on Private Health Insurance on policies paid on behalf of employees.',
  },
  rebateMedicareEligibleInformationText: {
    informationText: 'All the people listed on the policy must be eligible to claim Medicare for you to receive the rebate as a reduced premium.',
  },
  medicareCardTypeOptions: [
    {
      display: 'Green',
      returnValue: 'Green',
    },
    {
      display: 'Blue (Interim)',
      returnValue: 'Blue (Interim)',
    },
    {
      display: 'Yellow (Reciprocal)',
      returnValue: 'Yellow (Reciprocal)',
    },
  ],
  incomeTierSingleOptions: [
    {
      display: '$93,000 or less',
      returnValue: 'BASE_TIER',
    },
    {
      display: '$93,001 - $108,000',
      returnValue: 'TIER_1',
    },
    {
      display: '$108,001 - $144,000',
      returnValue: 'TIER_2',
    },
    {
      display: '$144,001 or more',
      returnValue: 'TIER_3',
    },
    {
      display: "Don't apply a rebate",
      returnValue: 'none',
    },
  ],
  incomeTierFamilyOptions: [
    {
      display: '$186,000 or less',
      returnValue: 'BASE_TIER',
    },
    {
      display: '$186,001 - $216,000',
      returnValue: 'TIER_1',
    },
    {
      display: '$216,001 - $288,000',
      returnValue: 'TIER_2',
    },
    {
      display: '$288,001 or more',
      returnValue: 'TIER_3',
    },
    {
      display: "Don't apply a rebate",
      returnValue: 'none',
    },
  ],
  incomeTierInformationText: {
    informationText:
      'Privacy and your personal information The privacy and security of your personal information is important to us, and is protected by law. We need to collect this information so we can process and manage your applications and payments, and provide services to you. We only share your information with other parties where you have agreed, or Page 11 of 13 where law allows or requires it. For more information, go to&nbsp;<a href="https://www.servicesaustralia.gov.au/individuals/privacy" target="_blank">servicesaustralia.gov.au/individuals/privacy</a>',
  },
  paymentPayingPremiumInformationText: {
    informationText:
      '<p>Direct debit from your bank account can occur every fortnight, month, quarter, half year or year.​ Credit card payments are made on the 15th of each month, quarter, half year or year​.</p>\r\n\r\n<p>I/We request and authorise Defence Health (ID 3478) to debit funds from my/our nominated account according to the details specified below through the Bulk Electronic Clearing System (BECS).</p>\r\n',
  },
  paymentMethodOptions: [
    {
      display: 'Bank account',
      returnValue: 'B',
    },
    {
      display: 'Credit card',
      returnValue: 'C',
    },
  ],
  paymentFrequencyOptions: [
    {
      display: 'Fortnightly',
      returnValue: 'Fortnightly',
    },
    {
      display: 'Monthly',
      returnValue: 'Monthly',
    },
    {
      display: 'Quarterly',
      returnValue: 'Quarterly',
    },
    {
      display: 'Semi-annual',
      returnValue: 'Semi-annual',
    },
    {
      display: 'Annual',
      returnValue: 'Annual',
    },
  ],
  paymentUnderstandDebitAgreementInformationText: {
    informationText:
      'I have read and understood the <a href="https://stdhlwebsitdata001.blob.core.windows.net/pdfdocuments/additional/Direct%20debit%20service%20agreement.pdf" target="_blank">Direct Debit service agreement</a>. I understand the first deduction after joining or changing cover may include the premium for the nominated payment frequency plus a pro-rata amount. If a deduction falls on a non-business day, it will be debited from my account on the next business day. I authorise Defence Health to alter the amount of the deduction, if the premium for my policy changes. I understand that it is a condition of my membership that premiums are paid in advance. Any changes to my direct debit must be requested at least 2 days prior to the next deduction.',
  },
  paymentCardProcessingFeeInformationText: {
    informationText: '',
  },
  paymentBankClaimsSameAccountInformationText: {
    informationText: 'When you submit a claim with us, we will deposit any benefits into your nominated bank account.',
  },
  paymentBankClaimsInformationText: {
    informationText:
      'Defence Health can automatically deposit claim payments directly into your nominated bank, building society or credit union account. By completing this section you will be nominating an account for direct claims payment.',
  },
  paymentBankClaimsAuthorizationInformationText: {
    informationText:
      'I authorise Defence Health to pay this membership&rsquo;s claims benefits directly into my nominated account. I acknowledge that the claims payments for this membership will continue to be paid to my nominated account until I register a new account.',
  },
  privacyPolicyInformationText: {
    informationText:
      'I declare and acknowledge that:​<br />\r\n<br />\r\nI have read and understood the <a href="/other/legal?open=one" target="_blank">Privacy Policy</a><br />\r\n<br />\r\nI have obtained the necessary consents from dependants over 16 years of age to disclose their personal information in this application form to Defence Health and give the same consents and authorisation I give in these declarations.​<br />\r\n<br />\r\nI will make, or authorise the making of claims under this policy​<br />\r\n<br />\r\nIf applicable I authorise my previous health funds to release to Defence Health all personal information concerning my dependants and me, which is required to confirm policy entitlements​<br />\r\n<br />\r\nI am aware that Defence Health hospital products are not suitable for non- residents without Medicare entitlements (including overseas visitors from countries with Australian Government reciprocal health care arrangements).​<br />\r\n<br />\r\nI have read and understood the product information contained in this website including limitation of benefits for pre-existing condition and waiting periods.​',
  },
  serviceTypeOptions: [
    {
      display: 'Permanent',
      returnValue: 'Permanent',
    },
    {
      display: 'Reservist',
      returnValue: 'Reservist',
    },
  ],
};

export const terminationReasonFlexCodes = {
  terminationReasons: {
    policyReasons: [
      {
        code: 'INV',
        description: 'Investigation',
      },
      {
        code: 'UNFIN',
        description: 'Unfinancial',
      },
    ],
    memberReasons: [
      {
        code: 'DIS',
        description: 'Deceased in Service',
      },
      {
        code: 'AGE',
        description: 'Overage',
      },
    ],
    bothReasons: [
      {
        code: 'PMSCE',
        description: 'Poor member service/claims experience',
      },
      {
        code: 'CICO',
        description: 'Change in cover offered',
      },
      {
        code: 'AFF',
        description: 'Affordability',
      },
      {
        code: 'TCP',
        description: 'To another fund- Cheaper premium',
      },
      {
        code: 'TFR',
        description: 'Transfer to another DHL membership',
      },
      {
        code: 'ES',
        description: 'Employer Subsidised',
      },
      {
        code: 'PUB',
        description: 'Will use public system',
      },
      {
        code: 'RSN',
        description: 'Reason not enclosed',
      },
      {
        code: 'TBPO',
        description: 'To another fund-Better product options',
      },
      {
        code: 'TBB',
        description: 'To another fund- Better benefits',
      },
      {
        code: 'TLP',
        description: 'To another fund-Loyalty Program',
      },
      {
        code: 'TAF',
        description: 'To another fund',
      },
      {
        code: 'THEAL',
        description: 'To another fund- Health & wellbeing service',
      },
      {
        code: 'DEC',
        description: 'Deceased',
      },
      {
        code: 'ENL',
        description: 'Enlisted',
      },
      {
        code: 'VET',
        description: 'Veteran Affairs',
      },
      {
        code: 'PRC',
        description: 'Premium Cost',
      },
      {
        code: 'RFC',
        description: 'Relationship/Family change',
      },
      {
        code: 'NVRM',
        description: 'Not Value for Money',
      },
      {
        code: 'TBSER',
        description: 'To another fund- Better service/reputation',
      },
      {
        code: 'TPROM',
        description: 'To another fund-Promotional offer',
      },
    ],
  },
};

export const fundNames = {
  value: [
    {
      name: 'ACA Health Benefits Fund',
      dhl_code: 'ACA',
      dhl_hiccode: 'ACA',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'AHM',
      dhl_code: 'AHM',
      dhl_hiccode: 'AHM',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Australian Unity Health Ltd',
      dhl_code: 'AU',
      dhl_hiccode: 'AU',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'BUPA Health Insurance',
      dhl_code: 'Unk3',
      dhl_hiccode: 'BUP',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'CBHS Corporate Health Pty Ltd',
      dhl_code: 'CBC',
      dhl_hiccode: 'CBC',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'CBHS Health Fund Ltd',
      dhl_code: 'CBHS',
      dhl_hiccode: 'CBH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'CDH Benefits Fund',
      dhl_code: 'CDH',
      dhl_hiccode: 'CDH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'CUA Health Fund',
      dhl_code: 'CUA',
      dhl_hiccode: 'CPS',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Defence Health Ltd',
      dhl_code: 'AHBS',
      dhl_hiccode: 'AHB',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Doctors Health Fund',
      dhl_code: 'AMA',
      dhl_hiccode: 'AMA',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Emergency Services Health',
      dhl_code: 'ESH',
      dhl_hiccode: 'ESH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'GMHBA Health Fund',
      dhl_code: 'GMHBA',
      dhl_hiccode: 'GMH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Uni Health Insurance',
      dhl_code: 'UHI',
      dhl_hiccode: 'UHI',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'HBF',
      dhl_code: 'HBF',
      dhl_hiccode: 'HBF',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'HCF',
      dhl_code: 'HCF',
      dhl_hiccode: 'HCF',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Health Care Insurance Ltd',
      dhl_code: 'HCI',
      dhl_hiccode: 'HCI',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'HIF',
      dhl_code: 'HIF',
      dhl_hiccode: 'HIF',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Latrobe Health Services Inc',
      dhl_code: 'LHS',
      dhl_hiccode: 'LHS',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Medibank Private',
      dhl_code: 'MP',
      dhl_hiccode: 'MP',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Mildura District Hospital Fund',
      dhl_code: 'MDHF',
      dhl_hiccode: 'MDH',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'One Medi Fund',
      dhl_code: 'OMF',
      dhl_hiccode: 'OMF',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Navy Health',
      dhl_code: 'NAVY',
      dhl_hiccode: 'NHB',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'NIB Health Funds Ltd',
      dhl_code: 'NIB',
      dhl_hiccode: 'NIB',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Nurses & Midwives Health',
      dhl_code: 'NMW',
      dhl_hiccode: 'NMW',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Peoplecare',
      dhl_code: 'LHMC',
      dhl_hiccode: 'LHM',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Phoenix Health Fund',
      dhl_code: 'PWAL',
      dhl_hiccode: 'PWA',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Police Health',
      dhl_code: 'SAPOL',
      dhl_hiccode: 'SPE',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Queensland Country Health Limited',
      dhl_code: 'QCH',
      dhl_hiccode: 'QCH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'R&T Health Fund',
      dhl_code: 'RTEFS',
      dhl_hiccode: 'RTE',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Reserve Bank Health Society',
      dhl_code: 'RBHS',
      dhl_hiccode: 'RBH',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: "St Luke's Health",
      dhl_code: 'SLMHB',
      dhl_hiccode: 'SL',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Teachers Health',
      dhl_code: 'NSWTF',
      dhl_hiccode: 'NTF',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Transport Health',
      dhl_code: 'TFS',
      dhl_hiccode: 'TFS',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Queensland teachers union',
      dhl_code: 'QTUHS',
      dhl_hiccode: 'QTU',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Westfund',
      dhl_code: 'WDHF',
      dhl_hiccode: 'WFD',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'APIA',
      dhl_code: 'Unk9',
      dhl_hiccode: 'NIB',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Grand United Corporate Health Fund',
      dhl_code: 'GUC',
      dhl_hiccode: 'GUC',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Health Partners',
      dhl_code: 'HP',
      dhl_hiccode: 'SPS',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Frank Health Insurance',
      dhl_code: 'Unk1',
      dhl_hiccode: 'GMH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Fit Health Insurance',
      dhl_code: 'Unk2',
      dhl_hiccode: 'GMH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Central West Health Fund',
      dhl_code: 'Unk4',
      dhl_hiccode: 'HBF',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Health.com',
      dhl_code: 'Unk5',
      dhl_hiccode: 'GMH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Budget Direct Health Insurance',
      dhl_code: 'Unk6',
      dhl_hiccode: 'GMH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'RACQ Health Insurance',
      dhl_code: 'Unk7',
      dhl_hiccode: 'MYO',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Qantas',
      dhl_code: 'Unk8',
      dhl_hiccode: 'NIB',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'AIA',
      dhl_code: 'AIA',
      dhl_hiccode: 'AIA',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'GMF Health Fund',
      dhl_code: 'GMF',
      dhl_hiccode: 'GMF',
      dhl_istransfergatewayenabled: false,
    },
  ],
};

export const submitChangeCoverResponse = {
  '@odata.context': 'https://dhl-delta-dev.api.crm6.dynamics.com/api/data/v9.1/$metadata#Microsoft.Dynamics.CRM.dhl_SubmitchangeofcoverResponse',
  responseString:
    '{\r\n  "memberNumber": "1022492",\r\n  "currentDate": "2022-12-20",\r\n  "changeStartDate": "2022-12-21",\r\n  "composition": {\r\n    "op": "none",\r\n    "value": "couple"\r\n  },\r\n  "myCircumstances": "other",\r\n  "state": {\r\n    "op": "none",\r\n    "value": "ACT"\r\n  },\r\n  "postcode": {\r\n    "op": "none",\r\n    "value": "2602"\r\n  },\r\n  "terminations": {\r\n    "products": [\r\n      {\r\n        "productCode": "I4",\r\n        "terminationReason": "INV"\r\n      },\r\n      {\r\n        "productCode": "J21",\r\n        "terminationReason": "INV"\r\n      }\r\n    ]\r\n  },\r\n  "residentialAddress": {\r\n    "op": "none",\r\n    "addressType": "S",\r\n    "addressLine1": "10 Flemington Rd",\r\n    "addressLine2": "",\r\n    "addressLine3": "",\r\n    "suburb": "LYNEHAM",\r\n    "postcode": "2602",\r\n    "state": "ACT",\r\n    "dpId": "62980700"\r\n    },\r\n  "mainPolicyHolder": {\r\n    "postalAddress": {\r\n      "op": "none",\r\n      "addressLine1": "PO Box 3",\r\n      "addressLine2": "",\r\n    "addressLine3": "",\r\n      "suburb": "ABBOTSFORD",\r\n      "postcode": "3067",\r\n      "state": "VIC",\r\n      "dpId": "85889820"\r\n    },\r\n    "veteranCard": {\r\n      "hasVeteranCard": true,\r\n      "veteranCardList": [\r\n        {\r\n          "startDate": "2022-12-01",\r\n          "cardType": "Veteran White Card",\r\n          "acceptedConditions": [],\r\n          "op": "none"\r\n        }\r\n      ]\r\n    },\r\n    "concessionCard": {\r\n      "hasConcessionCard": true,\r\n      "cardList": [\r\n        {\r\n          "id": "8325f50f-33f0-eb11-94ef-00224814eacc",\r\n          "cardType": "CSHC",\r\n          "cardNumber": "123131333a",\r\n          "expiryDate": "",\r\n          "startDate": "2022-12-01"\r\n        }\r\n      ]\r\n    }\r\n  },\r\n  "partner": {\r\n    "op": "none",\r\n    "personCode": "4822",\r\n    "veteranCard": {\r\n      "hasVeteranCard": false,\r\n      "veteranCardList": [\r\n        {\r\n          "cardType": "",\r\n          "acceptedConditions": []\r\n        }\r\n      ]\r\n    },\r\n    "concessionCard": {\r\n      "hasConcessionCard": false,\r\n      "cardList": null\r\n    }\r\n  },\r\n  "eligibility": {\r\n    "eligibilityType": "ADF",\r\n    "eligibilitySubject": "Self",\r\n    "subjectName": "",\r\n    "subjectRank": "",\r\n    "subjectRelation": "",\r\n    "subjectDepartmentOrCompanyName": "Navy",\r\n    "subjectServiceType": "Permanent",\r\n    "enlistmentDate": "2022-11-27",\r\n    "dischargeDate": "",\r\n    "sercatStatus": "SERCAT 3",\r\n    "workConnectionName": "",\r\n    "declarationDate": "2022-12-01",\r\n    "expiryDate": "2023-12-01",\r\n    "declarationIsConfirmed": true,\r\n    "op": "none"\r\n  },\r\n  "rebate": {\r\n    "op": "none"\r\n  },\r\n  "productList": [\r\n    {\r\n      "op": "add",\r\n      "productCode": "J19",\r\n      "excess": "500",\r\n      "productExcessType": "MEM_EXCESS"\r\n    },\r\n    {\r\n      "op": "add",\r\n      "productCode": "I3"\r\n    }\r\n  ],\r\n  "currentPremium": 207.22,\r\n  "newPremium": 347.37,\r\n  "currentPayFrequency": "fortnightly",\r\n  "newPayFrequency": "fortnightly"\r\n}',
  errorMessage: null,
};

export const premiumCalculatorReferenceData = {
  datePaidTo: '2022-06-13',
  coverStartDate: '2023-07-12',
  referenceData: {
    premiumCalculatorInformationText: {
      informationText: `
      <p>The premium calculator will help you find out how much you need to pay today to cover you to a selected date. Or check when you will be covered to after paying a particular amount today.</p><b>Remember</b><ul><li id="cache9">Your policy can only be paid up to 12 months in advance</li>\r\n\t<li id="cache11">The date you want to be covered to must be in the future</li>\r\n</ul>\r\n\r\n<p><strong>Set up a direct debit to stay on top of payments </strong><br />\r\nWith&nbsp;<a href="/$memberNumber$/payment-selection/" tabindex="0" target="_blank">automatic payments</a>, you don&rsquo;t have to keep track of when the next bill is due. You can set up:&nbsp; </p>\r\n\r\n<ul>\r\n\t<li id="cache22">a direct debit for regular withdrawal of money from your bank account </li>\r\n\t<li id="cache24">a recurring payment from your credit card&mdash;payments are due on the 15th of the month.</li>\r\n</ul>\r\n`,
    },
    relatedArticle1: {
      heading: 'How do I choose hospital cover?',
      toUrl: 'https://healthhq.defencehealth.com.au/2019/04/30/how-do-i-choose-hospital-cover/',
      imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2019/04/How-do-I-choose-hospital-cover-1024x683.jpg',
      imageAltText: 'family image',
      tag: 'Family',
      listedTime: '2021-08-18T14:02:57',
    },
    relatedArticle2: {
      heading: 'Keeping your cover affordable',
      toUrl: 'https://healthhq.defencehealth.com.au/2016/02/19/keeping-your-cover-affordable/',
      imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2016/02/Lady-on-Laptop-affordability-resized-1024x683.jpg',
      imageAltText: 'person on laptop',
      tag: 'Affordable',
      listedTime: '2021-08-18T14:03:35',
    },
    relatedArticle3: {
      heading: 'Make the most out of your health care',
      toUrl: 'https://healthhq.defencehealth.com.au/2016/08/31/make-health-care/',
      imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2016/08/Image-Benefits-of-PHI.jpg',
      imageAltText: 'hospital',
      tag: 'Wellness',
      listedTime: '2021-08-18T14:03:37',
    },
  },
};

export const makeAPaymentReferenceData = {
  makeAPaymentFullAccessInformationText: {
    informationText:
      '<p>Keep your premiums up to date. Make a premium payment anytime using a credit card.</p>\r\n\r\n<p>Set up a <a href="/$memberNumber$/payment-selection">direct debit</a> and never miss a payment.</p>\r\n',
  },
  makeAPaymentSelfAccessInformationText: {
    informationText: '<p>Keep your premiums up to date. Make a premium payment anytime using a credit card.</p>\r\n',
  },
  paymentAmountInformationText: {
    informationText:
      '<p>Premiums can be paid up to 12 months in advance. The maximum payment you can make today is #{maximumPaymentAmount}.</p>\r\n\r\n<p>Use our <a href="/$memberNumber$/my-cover/Premium-calculator">premium calculator</a> to confirm the date your payment will provide cover up to for this membership.</p>\r\n',
  },
  cardFeeInformationText: {
    informationText: '',
  },
  cardNumberHelpText: {
    informationText: '<p>We accept payments from Visa or Mastercard.</p>\r\n',
  },
  newCardHelpText: {
    informationText: '<p>This card will not be stored.</p>\r\n',
  },
  nominatedCardHelpText: {
    informationText: '<p>Card details will not be stored, or overwrite existing card details or payment method.</p>\r\n',
  },
  makeAPaymentConfirmationText: {
    informationText: '<p>By submitting this payment, you are authorising Defence Health to make a charge to your nominated credit card.</p>\r\n',
  },
  sessionTimeoutInformationText: {
    informationText: '<p>Sorry, your session timed out. Please provide your payment details again to make a payment.</p>\r\n',
  },
  datePaidToOver12MonthsInformationText: {
    informationText:
      '<p>Sorry, we couldn’t accept that payment amount. Premiums can be paid up to 12 months in advance. The amount you wish to pay exceeds 12 months of cover. Please enter another amount, or alternatively use the <a href="/my-cover/premium-calculator">premium calculator</a> to calculate a payment amount.</p>',
  },
  maximumPaymentAmount: {
    informationText: '20500',
  },
  cardExpiryErrorMessage: {
    informationText: '<p>Sorry, the expiry date on the credit card you entered appears invalid. Please review and update the card details.</p>',
  },
};

export const makeAPaymentCardDetail = {
  accountHolderName: 'card name',
  accountNumberOrToken: 'mockToken',
  bsb: '123 - 123',
  confirmUseAgreement: true, // currently not in use
  accountType: 'C', // for mock, it has to be 'C'
  maskedCreditCardNumber: '************0005',
  expiryDate: '2024-12-31',
};

export const makePayment = {
  step: null,
  source: null,
  originalDatePaidTo: '2023-08-26',
  amountPaid: '1001',
  messageCode: null,
  contributionDates: {
    current: '2023-12-14',
    next: '2024-03-14',
  },
  paymentReference: '2023101828900895',
  newDatePaidTo: '2023-08-28',
};

export const paymentSuccessReferenceData = {
  paymentSuccessInformationText: {
    informationText: 'Your premium payment has been received.<br>\r\nRemember credit card payments will appear in your payment history by the next business day.&nbsp;',
  },
  paymentSuccessDatePaidToCalloutText: {
    informationText:
      '<h3><strong>This membership is covered until #{DPT}</strong></h3>\r\n\r\n<p>Don&rsquo;t forget you can <a href="/portal/$memberNumber$/my-claims/claims/make-a-claim">submit your claims</a> online for fast easy payment.</p>\r\n',
  },
  paymentSuccessDatePaidToErrorCalloutText: {
    informationText:
      '<h3><strong>Your payment has been received​</strong></h3>\r\nWe are currently unable to confirm the date your payment will provide cover up to for this membership.​<br />\r\n<br />\r\nPlease check back again shortly.',
  },
  paymentSuccessCalloutIcon: {
    informationText: '~/assets/public/images/icon_add.svg',
  },
  relatedPage1: {
    heading: 'Make a claim',
    description: 'Fast online claims for most extras services',
    toUrl: '~/portal/$memberNumber$/my-claims/claims/make-a-claim',
    imageUrl: '~/getmedia/c5b78a3f-7b44-4f5c-bf57-6bd8f4c8dc9f/blogimage4.jpg?width=1024&height=682&ext=.jpg',
    imageAltText: 'people',
  },
  relatedPage2: {
    heading: 'Extras limits and usage',
    description: 'Check your limits and how much you can claim',
    toUrl: '~/',
    imageUrl: '~/getmedia/95d45099-47d5-4b04-b2a6-27fa7fc7bb98/blogimage3.jpg?width=1024&height=682&ext=.jpg',
    imageAltText: 'child',
  },
  relatedPage3: {
    heading: 'Hospital eligibility check',
    description: "Going to the hospital? Check whether you're covered.",
    toUrl: '~/portal/$memberNumber$/Support/Contact-Us',
    imageUrl: '~/getmedia/06ccfb89-2fbf-45df-b220-ead225c4fbd0/large.jpg?width=2400&height=854&ext=.jpg',
    imageAltText: 'bridge',
  },
};
